import styled from 'styled-components'

export const TurnstileWrapper = styled.div(({ styles }) => ({
  textAlign: 'center',
  ...styles,
}))
